export const CONTACT_EMAIL = "anytoolonline@gmail.com";

declare const __PUBLIC_CONFIG__: {
  adsenseBase64TopSlot?: string;
  adsenseClient?: string;
  adsenseFormatTopSlot?: string;
  adsenseHashTopSlot?: string;
  adsenseImageCompressTopSlot?: string;
  adsensePdfConvertTopSlot?: string;
  adsensePdfMergeTopSlot?: string;
  adsenseQrTopSlot?: string;
  adsenseWordCountTopSlot?: string;
  apiBasePath?: string;
  googleAnalyticsId?: string;
};

export const publicConfig = {
  adsenseBase64TopSlot: __PUBLIC_CONFIG__.adsenseBase64TopSlot ?? "",
  adsenseClient: __PUBLIC_CONFIG__.adsenseClient ?? "",
  adsenseFormatTopSlot: __PUBLIC_CONFIG__.adsenseFormatTopSlot ?? "",
  adsenseHashTopSlot: __PUBLIC_CONFIG__.adsenseHashTopSlot ?? "",
  adsenseImageCompressTopSlot: __PUBLIC_CONFIG__.adsenseImageCompressTopSlot ?? "",
  adsensePdfConvertTopSlot: __PUBLIC_CONFIG__.adsensePdfConvertTopSlot ?? "",
  adsensePdfMergeTopSlot: __PUBLIC_CONFIG__.adsensePdfMergeTopSlot ?? "",
  adsenseQrTopSlot: __PUBLIC_CONFIG__.adsenseQrTopSlot ?? "",
  adsenseWordCountTopSlot: __PUBLIC_CONFIG__.adsenseWordCountTopSlot ?? "",
  apiBasePath: __PUBLIC_CONFIG__.apiBasePath ?? "",
  googleAnalyticsId: __PUBLIC_CONFIG__.googleAnalyticsId ?? ""
};
